import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VerificationTaskService {

  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  createTask(data: any): any {
    return this.http.post(`${environment.apiUrl}/VerificationTask/CreateTask`, data);
  }

  getListTasksByAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/ListTasksByAdmin`, { params });
  }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/ListVerificationTasks`, { params });
  }

  getTaskLogs(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetTaskLogs?taskId=${taskId}`);
  }

  getAvailableActions(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetAvailableActions?taskId=${taskId}`);
  }

  changeTaskStatus(data: any): any {
    return this.http.post(`${environment.apiUrl}/VerificationTask/ChangeTaskStatus`, data);
  }

  removeTask(id: number) {
    return this.http.delete(`${environment.apiUrl}/VerificationTask/RemoveTask?id=${id}`);
  }


  getRelatedTracks(hubCode): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetRelatedTracks?hubCode=${hubCode}`);
  }

  getRelatedGroups(params: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetRelatedGroups`, { params });
  }

  getRelatedAmbassadros(params: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetRelatedAmbassadros`, { params });
  }

  getTaskQuestionsCheckFormForDetails(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetTaskQuestionsCheckFormForDetails?taskId=${taskId}`);
  }

  getListTasksByAmbassador(params: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/ListTasksByAmbassador`, { params });
  }

  getTaskDetails(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetTaskDetails?taskId=${taskId}`);
  }
  getAllTaskComments(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetAllTaskComments?taskId=${taskId}`);
  }

  addTaskComment(data: any): any {
    return this.http.post(`${environment.apiUrl}/VerificationTask/AddTaskComment`, data);
  }
  updateTaskComment(data: any): any {
    return this.http.put(`${environment.apiUrl}/VerificationTask/UpdateTaskComment`, data);
  }
  deleteTaskComment(commentId: any): any {
    return this.http.delete(`${environment.apiUrl}/VerificationTask/DeleteTaskComment?commentId=${commentId}`);
  }

  getInstitutionsToEscalate(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetInstitutionsToEscalate?taskId=${taskId}`);
  }
  getTaskQuestionsCheckFormForSubmit(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/VerificationTask/GetTaskQuestionsCheckFormForSubmit?taskId=${taskId}`);
  }

  saveTaskDraftAnswers(data: any): any {
    return this.http.post(`${environment.apiUrl}/VerificationTask/SaveTaskDraftQuestionAnswers`, data);
  }

  saveTaskAnswers(data: any): any {
    return this.http.post(`${environment.apiUrl}/VerificationTask/SubmitTaskQuestionAnswer`, data);
  }
}
